/* eslint-disable max-len */
import React from 'react'
import type { HTMLElementProps } from '~/types'
import { cn } from '~/utils'

type Props = HTMLElementProps<'svg'>

export const Close: React.FC<Props> = ({ className, height = '1em', ...props }) => (
	<svg
		className={cn('align-middle', className)}
		aria-hidden="true"
		focusable="false"
		role="presentation"
		viewBox="0 0 16.8 16.8"
		width={height}
		height={height}
		fill="currentColor"
		{...props}
	>
		<path d="M16.8 1.5L15.4.1 8.4 7l-7-7L0 1.4l7 7-7 7 1.4 1.4 7-7 7 7 1.4-1.4-7-7z" />
	</svg>
)
